<!-- <header app-header class="topbar is_stuck" style="position: fixed; top: 0; width: 100%;">-->
  <header class="topbar">
  <nav class="navbar top-navbar navbar-expand-md navbar-light">
      <!-- ============================================================== -->
      <!-- Logo -->
      <!-- ============================================================== -->
      <div class="navbar-header">
          <a class="navbar-brand" routerLink="/principal">
              <!-- Logo icon -->
              <b>
                  <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                  <!-- Dark Logo icon -->
                  <img src="assets/images/lh.png" alt="homepage" class="dark-logo" />
                  <!-- Light Logo icon -->
                  <img src="assets/images/lhb.png" alt="homepage" class="light-logo" />
              </b>
              <!--End Logo icon -->
              <!-- Logo text -->
              <span>
               <!-- dark Logo text -->
               <img src="assets/images/lhtextob.png" alt="homepage" class="dark-logo" />
               <!-- Light Logo text -->
               <img src="assets/images/lhtextow.png" class="light-logo" alt="homepage" /></span> </a>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div class="navbar-collapse">
          <!-- ============================================================== -->
          <!-- toggle and nav items -->
          <!-- ============================================================== -->
          <ul class="navbar-nav mr-auto mt-md-0">
              <!-- This is  -->
              <li class="nav-item"> <a class="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="mdi mdi-menu"></i></a> </li>
              <li class="nav-item"> <a class="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>



          </ul>
          <!-- ============================================================== -->
          <!-- User profile and search -->

          <!-- ============================================================== -->
          <ul class="navbar-nav my-lg-0">
              <!-- ============================================================== -->
             <!-- ============================================================== -->


              <!-- Comment -->
                        <!-- ============================================================== -->
                        <li class="nav-item dropdown">
                          <a class="nav-link dropdown-toggle text-muted text-muted waves-effect waves-dark"
                          routerLink="/principal" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="mdi mdi-magnify"></i>
                              <div class="notify"> <span class="heartbit"></span> <span class="point"></span> </div>
                          </a>

                      </li>
                      <!-- ============================================================== -->
                      <!-- End Comment -->


              <!-- ============================================================== -->
              <!-- Profile -->
              <!-- ============================================================== -->
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark"
                  href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  <img [src]="fotoPerfil | imagen" alt="user" class="profile-pic"/>
                </a>

                  <div class="dropdown-menu dropdown-menu-right scale-up">
                      <ul class="dropdown-user">
                          <li>
                              <div class="dw-user-box" style="text-align: center;">
                                  <div class="u-img"><img [src]="fotoPerfil | imagen" alt="user"></div>
                                  <div class="u-text">
                                      <h4>{{usuario.nombre}}</h4>
                                      <p class="text-muted">{{usuario.correo}}</p>
                                      <p>{{usuario.rol}}</p>
                                    </div>
                              </div>
                          </li>
                          <li role="separator" class="divider"></li>
                          <li><a routerLink="/perfil"><i class="ti-user"></i> Mi Perfil</a></li>
                                  <li><a routerLink="/cambiarpassword"><i class="ti-key"></i> Cambiar Contraseña</a></li>
                                  <li role="separator" class="divider"></li>
                                  <li><a (click)="_usuarioService.logout()" class="pointer"><i class="fa fa-power-off"></i> Salir</a></li>
                      </ul>
                  </div>
              </li>

          </ul>
      </div>
  </nav>
</header>
